import { Fragment } from 'react';
import { useImages } from '../context/ImageContext';
const { GetRequiredHappyFaces } = require('@tta/engine/Utilities/Utilities');
const { Image } = require("react-bootstrap");

const imageStyle = {
    width: 'auto',
    height: '15px',
}

const consumptionTdStyle = {
    color: '#ddcc00',
    backgroundColor: '#6c5b36',
}

const bankStyle = {
    backgroundColor: '#c9c497'
}

// HappyFaces: the civilization's happy faces, marked on the track above the bank with the player's cube.
// Color: the player's color, as the viewer sees it (see SeatColors), the cube's.
function YellowBank({count, HappyFaces = 0, Color})
{
    return (
        <table style={{width: '100%'}}>
            <thead>
                <TableHeaders count={count} happyFaces={HappyFaces} color={Color} />
            </thead>
            <tbody>
                <TableContent count={count} />
                <TableCosts count={count} />
            </tbody>
        </table>
    )
}

// The happy-face track: one slot above each subsection of the bank, worth (left to right) 8 down to 1, and 0 above
// the "0" column. The cube sits in the slot matching the happy faces. A subsection that has been emptied needs that
// many happy faces; if there are not enough, its face is shown upset (a discontent worker).
function TableHeaders({count, happyFaces, color})
{
    const { images } = useImages();
    const required = GetRequiredHappyFaces(count);

    const extraColumns = count <= 18 ? 0 : Math.floor((count-17)/2);

    const slot = (value, colSpan = 1) => {
        let image = images.Happiness.src;
        let title = `${value} happy face${value === 1 ? '' : 's'}`;
        if (value === happyFaces)
        {
            // (a cube like those on the culture and military tracks)
            return <th key={`slot ${value}`} colSpan={colSpan} title={title}>
                <span className="tta-track-token tta-happy-cube" style={{ backgroundColor: color }}/>
            </th>;
        } else if (value > happyFaces && value <= required)
        {
            image = images.Unhappy.src;
            title = 'Not enough happy faces: a discontent worker';
        }
        return <th key={`slot ${value}`} colSpan={colSpan} title={title}><Image src={image} style={imageStyle}/></th>;
    };
    const gap = (key) => <th key={`gap ${key}`}/>;

    const items = [
        gap(6),
        slot(8),
        slot(7),
        gap(4),
        slot(6),
        slot(5),
        gap(3),
        slot(4),
        slot(3),
        gap(2),
        slot(2, 2),
        gap(1),
        slot(1, 1 + extraColumns),
        slot(0),
    ];
    return (
        <tr>
            {items}
        </tr>
    )
}

function TableCosts({count})
{
    const { images } = useImages();

    const extraColumns = count <= 18 ? 0 : Math.floor((count-17)/2);
    const costs = [
        <th/>,
        <th colSpan="2">7<Image src={images.Food.src} style={imageStyle}/></th>,
        <th/>,
        <th colSpan="2">5<Image src={images.Food.src} style={imageStyle}/></th>,
        <th/>,
        <th colSpan="2">4<Image src={images.Food.src} style={imageStyle}/></th>,
        <th/>,
        <th colSpan="2">3<Image src={images.Food.src} style={imageStyle}/></th>,
        <th/>,
        <th colSpan={1+extraColumns}>2<Image src={images.Food.src} style={imageStyle}/></th>,
        <th/>,
    ]
    return (
        <tr>
            {costs.map((cell, index) => <Fragment key={index}>{cell}</Fragment>)}
        </tr>
    )
}

function TableContent({count})
{
    const { images } = useImages();
    const loopCountAlteration = count > 18 ? Math.floor((count+1-18)/2): 0 ;
    const items = [];
    for (let i=0; i<15 + loopCountAlteration; i++)
    {
        items.push(<Fragment key={i}>{getContent(i, count, images)}</Fragment>)
    }
    return (
        <tr>
            {items}
        </tr>
    )
}

function getContent(index,count,images)
{
    if (index % 3 === 0 && index < 13){
        var cost = (index / 3) - 5;
        if (index === 0)
            cost = -6;
        return (
            <td style={consumptionTdStyle}>
                {cost}
                <Image src={images.Food.src} style={imageStyle}/>
            </td>
        )
    }
    if (index <14)
    {
        var indexInCols = Math.floor((index) * 2/3);
        return <td style={bankStyle}>
            <Image src={GetSource(indexInCols*2+1<=count)} style={imageStyle}/>
            <br />
            <Image src={GetSource(indexInCols*2+2<=count)} style={imageStyle}/>
        </td>
    }
    if (count <= 18)
    {
        return <td style={consumptionTdStyle}>
            0
            <Image src={images.Food.src} style={imageStyle}/>
        </td>
    }
    const numberExtraCols = (count-17)/2;
    const currentExtraCol = index - 13;
    if (currentExtraCol>numberExtraCols)
    {
        return (
            <td style={consumptionTdStyle}>
                0
                <Image src={images.Food.src} style={imageStyle}/>
            </td>
        )
    }
    return (
        <td style={bankStyle}>
            <Image src={GetSource(true)} style={imageStyle}/>
            <br />
            <Image src={GetSource(count-18>(currentExtraCol-1)*2+1)} style={imageStyle}/>
        </td>
    )
}

function GetSource(isFull)
{
    const { images } = useImages();

    return isFull ? images.YellowCube.src : images.MissingCube.src;
}

export default YellowBank;